import { useEffect, useMemo } from 'react';
import { useAppDispatch, useAppSelector } from '../redux';
import { selectIsAuthenticated, selectIsAuthInitialized } from '../features/AuthSlice/AuthSelectors';
import { loginVerified, previewLoginVerified } from '../features/AuthSlice/AuthSlice';
import { selectIsPreview, selectPreviewJwt } from '../features/PreviewSlice/PreviewSelectors';
import { getMembershipLoginUrl } from '../constants/urls';
export const useLoginVerify = () => {
  const dispatch = useAppDispatch();
  const isAuthenticated = useAppSelector(selectIsAuthenticated);
  const isAuthInitialized = useAppSelector(selectIsAuthInitialized);
  const isPreview = useAppSelector(selectIsPreview);
  const previewJwt = useAppSelector(selectPreviewJwt);
  const membershipLoginUrl = useMemo(() => getMembershipLoginUrl(window.location.href), []);
  useEffect(() => {
    if (isPreview) {
      // An empty-string previewJwt will fail the preview login RPC and surface
      // as a clear auth failure, which is preferable to silently hanging in
      // the loading state if the URL was missing the JWT fragment.
      void dispatch(previewLoginVerified(previewJwt !== null && previewJwt !== void 0 ? previewJwt : ''));
    } else {
      void dispatch(loginVerified());
    }
  }, [dispatch, isPreview, previewJwt]);
  useEffect(() => {
    if (isPreview) {
      return;
    }
    // redirect to Membership Platform login if auth check has settled and user is not authenticated
    if (isAuthInitialized && !isAuthenticated) {
      window.location.replace(membershipLoginUrl);
    }
  }, [isAuthenticated, isAuthInitialized, isPreview, membershipLoginUrl]);
  return {
    loading: !isAuthInitialized,
    isLoggedIn: isAuthenticated
  };
};